<template>
<main id="main-container">
    <Hero title="Consultar Datos" page="tranzabilidad"></Hero>
    <div class="content">
        <div class="row">
            <div class="col-sm-12">
            <card v-if="$store.state.devices.length == 0" title="No ha registrado ningun dispositivo">                    
            </card>

            <card v-if="$store.state.devices.length > 0" :title="`Dispositivo: ${$store.state.selectedDevice.name }`" >
                <div class="row">
                    <card class="col-sm-4" title="Seleccionar Una Variable" >
                            <div>
                                <select
                                required
                                class="form-select"
                                placeholder="Variable"
                                v-model="selectedWidgetIndex"
                                >
                                <option :key="index" v-for="(widget, index) in $store.state.selectedDevice.template.widgets" 
                                class="text-dark" :value="index" >  
                                    {{ widget.variableFullName }}
                                </option>
                                </select>
                            </div>
                            <br />
                    </card>

                <card class="col-sm-4" title="Desde:">
                    <input class="form-control" type="date" v-model="dateStart" >
                </card>

                <card class="col-sm-4" title="Hasta:">
                    <input class="form-control" type="date" v-model="dateEnd">
                </card>
                </div>

                <div class="row pull-right">
                <div class="col-12">
                    <button
                    @click="checkForm()"
                    type="submit"
                    class="btn btn-info mb-3"
                    :disabled="$store.state.devices.length == 0"
                    >
                    Consultar
                </button>
                </div>
                </div>
            </card>
            </div>
            <div class="col-sm-12">
            <Rtnumberchart
                :config="fixWidget(widget)"
                v-if="widget != null"
                :traceability="true"
            ></Rtnumberchart>
            </div>
        </div>
    </div>
</main>
</template>

<script>
import { useToast } from 'vue-toastification'
import Card from '@/components/Cards/Card.vue';
import Rtnumberchart from '@/components/Widgets/Rtnumberchartrange.vue';
export default {
    components:
    { card:Card,
    Rtnumberchart
    }
,
    data() {
    return {
        widget: null,
        selectedWidgetIndex: null,
        dateStart: "",
        dateEnd: "",
        toast: useToast()
    };
        },
    methods: {
    fixWidget(widget) {
        let widgetCopy = JSON.parse(JSON.stringify(widget));
        widgetCopy.selectedDevice.dId = this.$store.state.selectedDevice.dId;
        widgetCopy.selectedDevice.name = this.$store.state.selectedDevice.name;
        widgetCopy.userId = this.$store.state.selectedDevice.userId;
        widgetCopy.traceability = true;
        widgetCopy.dateStart = this.updateDate(this.dateStart);
        widgetCopy.dateEnd = this.updateDate(this.dateEnd) + 24 * 3600 * 1000;
        this.widget =
        this.$store.state.selectedDevice.template.widgets[
            this.selectedWidgetIndex
        ];
        if (widget.widget == "numberchart") {
        widgetCopy.demo = false;
        }

        return widgetCopy;
    },

    checkForm() {
        const dateStart_time = this.updateDate(this.dateStart);
        const dateEnd_time = this.updateDate(this.dateEnd);
        if (this.selectedWidgetIndex === null) {

        this.toast("Por favor escoger una variable !", {
            timeout: 5000,
            icon: `fas fa-comment-dots`,
        })
        return;
        }
        if (this.dateStart === "" || this.dateEnd === "") {
            
            this.toast("Por favor Seleccionar Fechas !", {
            timeout: 5000,
            icon: `fas fa-comment-dots`,
            })
            return;
        }
        if (dateStart_time == dateEnd_time) {

            this.toast("Por favor Seleccionar Fechas diferentes!", {
            timeout: 5000,
            icon: `fas fa-comment-dots`,
            })
        return;
        }

        if (dateStart_time > dateEnd_time) {

            this.toast("Por favor Seleccionar una fecha final mayor a la inicial", {
            timeout: 5000,
            icon: `fas fa-comment-dots`,
            })
        }

        if (dateEnd_time - dateStart_time > 30 * 24 * 3600 * 1000) {

            this.toast("Por favor Seleccionar rangos no superiores a 30 dias", {
            timeout: 5000,
            icon: `fas fa-comment-dots`,
            })
        return;
        }

        this.searchData();
        return;
    },
    updateDate(stringDate) {
        stringDate = stringDate.replace(/-/g, "/");
        const date = new Date(stringDate).getTime();
        return date;
    },

    searchData() {
        this.widget =
        this.$store.state.selectedDevice.template.widgets[
            this.selectedWidgetIndex
        ];

    },
    },
};
</script>
